import '.j3{display:inline-block;}.ssr-plugin'
import '.j4{margin-top:1.5rem;}.ssr-plugin'
import '.be{font-size:0.875rem;}.ssr-plugin'
import '.j5{color:var(--palette-blue-500);}.ssr-plugin'
import '.h7{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="j3 j4 be j5 h7"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
